import clientApi from '~/clientApi';
import { TiktokType } from '~/types';

export const getTiktokContents = async (
  contentIds = [],
  sharedToken?: string,
  creatorId?: string,
): Promise<TiktokType[]> =>
  Promise.all(
    (contentIds || []).map((id) =>
      clientApi.ttContents.read({
        id,
        _sharedToken: sharedToken,
        _impersonateOnce: creatorId,
      }),
    ),
  );

export const getTiktokInsights = (
  mediaPackId: string,
  sharedToken?: string,
  creatorId?: string,
) =>
  clientApi.mediaPacks.ttInsights({
    id: mediaPackId,
    _sharedToken: sharedToken,
    _impersonateOnce: creatorId,
  });
